import { render } from "./TransactionsComponent.vue?vue&type=template&id=8135a20e&scoped=true"
import script from "./TransactionsComponent.vue?vue&type=script&lang=js"
export * from "./TransactionsComponent.vue?vue&type=script&lang=js"

import "./TransactionsComponent.vue?vue&type=style&index=0&id=8135a20e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8135a20e"]])

export default __exports__